import { render, staticRenderFns } from "./VdGroupItem.vue?vue&type=template&id=8c3b806a&scoped=true"
import script from "./VdGroupItem.vue?vue&type=script&lang=js"
export * from "./VdGroupItem.vue?vue&type=script&lang=js"
import style0 from "./VdGroupItem.vue?vue&type=style&index=0&id=8c3b806a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3b806a",
  null
  
)

export default component.exports